import Image from "next/image";
import Link from "next/link";
const truncateWords = (text, maxWords) => {
  if (!text) return "";

  const words = text.trim().split(/\s+/);
  return words.length > maxWords
    ? words.slice(0, maxWords).join(" ") + "..."
    : text;
};

const RelevantCourses = ({ courses }) => {
    if (!courses || courses.length === 0) {
        return null;
    }

    return (
        <div className="lg:border lg:border-[#D7DFE6] lg:px-[28px] lg:py-[16px]">
            <h2 className="text-2xl leading-[40px] mb-[12px] text-[#202124]">
                Explore Relevant Courses
            </h2>

            <div className="flex flex-col max-h-[600px] overflow-y-auto pr-[10px] custom-scrollbar">
                {courses.map((course, index) => {
                    const imageUrl = course.course_image?.url;
                    const pointers = course.pointer || [];

                    return (
                        <div key={course.id}>
                            <Link href={`/course/${course.slug}`}>
                                <div className="flex gap-[16px] py-[16px] cursor-pointer group">
                                    {/* Cover image */}
                                    {imageUrl ? (
                                        <div className="relative w-[80px] h-[60px] sm:w-[110px] sm:h-[80px] md:w-[150px] md:h-[110px] flex-shrink-0 overflow-hidden bg-[#EEF4F9]">
                                            <Image
                                                src={imageUrl}
                                                alt={course.name}
                                                fill
                                                sizes="(max-width: 640px) 80px, (max-width: 768px) 110px, 150px"
                                                className="object-cover"
                                            />
                                        </div>
                                    ) : (
                                        <div
                                            className="w-[80px] h-[60px] sm:w-[110px] sm:h-[80px] md:w-[150px] md:h-[110px] flex-shrink-0 bg-[#EEF4F9] border border-[#D7DFE6] flex items-center justify-center text-[#4A5568] text-[10px] sm:text-xs md:text-sm text-center px-1"
                                            style={{ fontFamily: "saans-medium" }}
                                        >
                                            No Image
                                        </div>
                                    )}

                                    {/* Details */}
                                    <div className="flex flex-wrap gap-[8px]">
                                        <h3
                                            className="text-[16px] leading-[22px] text-[#202124] group-hover:underline"
                                            style={{ fontFamily: "saans-medium" }}
                                        >
                                            {truncateWords(course.name,5)}
                                        </h3>

                                        {pointers.length > 0 && (
                                            <div className="flex flex-wrap items-start gap-[4px]">
                                                {pointers.map((p, i) => (
                                                    <div
                                                        key={i}
                                                        className="flex items-center gap-[6px] px-[4px] py-[4px] bg-[#F5F7F9] border border-[#E3E8EC] rounded-full"
                                                    >
                                                        {p.pointer_icon && (
                                                            <div className="relative w-[16px] h-[16px] flex-shrink-0">
                                                                <Image
                                                                    src={p.pointer_icon?.url || p.pointer_icon}
                                                                    alt="Pointer Icon"
                                                                    fill
                                                                    sizes="16px"
                                                                    className="object-contain"
                                                                />
                                                            </div>
                                                        )}
                                                        <span
                                                            className="text-[12px] text-[#4A5568]"
                                                            style={{ fontFamily: "saans-regular" }}
                                                        >
                                                            {p.pointer}

                                                        </span>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </Link>

                            {index < courses.length - 1 && (
                                <hr className="border-t border-[#E3E8EC]" />
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default RelevantCourses;